/* HOPER · page de presentation professionnelle.
   11/09/2026. Le mouvement vit ici et pas dans le gabarit : la section Liquid
   est plafonnee a 50 ko par Shopify, et un script depose en fichier de theme
   se met en cache cote navigateur au lieu d'etre renvoye a chaque page.

   Quatre comportements, aucun cadre importe :
   1. apparition au defilement    [data-h1p-reveal], une seule fois
   1 bis. verbes rayes            .h1p-plus-ligne, a chaque passage
   2. parallaxe douce sur image   [data-h1p-parallax]
   3. image epinglee, texte qui monte et s'efface au fil du defilement  .h1p-pin
   4. fil de progression en tete de fenetre        .h1p-jauge-page

   Tout est desactive si le visiteur a demande moins d'animation.

   Note du 11/09/2026 : les apparitions passaient par un IntersectionObserver.
   Les titres se decouvrent avec un clip-path, et Chrome compte ce clip dans
   l'aire visible : un titre entierement replie n'etait jamais vu comme
   « entre a l'ecran », donc jamais revele. Dix titres sont restes invisibles
   en ligne. Tout passe desormais par la meme boucle de defilement, qui mesure
   la position reelle et ne peut pas etre piegee par un effet de peinture. */
(function () {
  'use strict';

  var racine = document.querySelector('.h1p');
  if (!racine) return;

  var sobre = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sobre) {
    racine.classList.add('h1p--sobre');
    return;
  }
  racine.classList.add('h1p--anime');

  /* ---------- ce qui reste a reveler ------------------------------- */
  var aVoir = [].slice.call(racine.querySelectorAll('[data-h1p-reveal]'));
  aVoir.forEach(function (el) {
    // le rang sert au decalage : les blocs d'un meme groupe entrent l'un apres l'autre
    if (!el.hasAttribute('data-h1p-rang')) {
      var p = el.parentNode;
      var freres = p ? [].filter.call(p.children, function (c) {
        return c.hasAttribute && c.hasAttribute('data-h1p-reveal');
      }) : [];
      el.setAttribute('data-h1p-rang', String(Math.min(Math.max(freres.indexOf(el), 0), 5)));
    }
    el.style.transitionDelay = (parseInt(el.getAttribute('data-h1p-rang'), 10) * 90) + 'ms';
  });

  // Les ratures, elles, se rejouent : on pose et on retire la classe au vol.
  var rayures = [].slice.call(racine.querySelectorAll('.h1p-plus-ligne'));

  var paras = [].slice.call(racine.querySelectorAll('[data-h1p-parallax]'));
  var pins = [].slice.call(racine.querySelectorAll('.h1p-pin'));
  var jauge = racine.querySelector('.h1p-jauge-page span');

  var enAttente = false;

  function place() {
    enAttente = false;
    var h = window.innerHeight;

    /* 1. apparitions : des que le haut du bloc passe sous 88 % de la fenetre */
    for (var i = aVoir.length - 1; i >= 0; i--) {
      var el = aVoir[i];
      var b = el.getBoundingClientRect();
      if (b.top < h * 0.88 && b.bottom > 0) {
        el.classList.add('est-vu');
        aVoir.splice(i, 1);
      }
    }

    /* 1 bis. les verbes rayes : le trait se retire des que la ligne sort du
       champ, pour se retirer a nouveau au passage suivant */
    for (var k = 0; k < rayures.length; k++) {
      var rl = rayures[k].getBoundingClientRect();
      rayures[k].classList.toggle('est-raye', rl.top < h * 0.85 && rl.bottom > h * 0.12);
    }

    /* 4. fil de progression : ou en est-on dans la page */
    if (jauge) {
      var total = document.documentElement.scrollHeight - h;
      var av = total > 0 ? (window.pageYOffset || document.documentElement.scrollTop) / total : 0;
      if (av < 0) av = 0; else if (av > 1) av = 1;
      jauge.style.transform = 'scaleX(' + av.toFixed(4) + ')';
    }

    /* 2. parallaxe */
    paras.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > h + 200) return;
      // -1 quand la section arrive, +1 quand elle sort : deplacement de 4 % maxi,
      // soit moins que la marge de debordement, pour ne jamais decouvrir un bord
      var t = (r.top + r.height / 2 - h / 2) / (h / 2 + r.height / 2);
      if (t < -1) t = -1; else if (t > 1) t = 1;
      var img = el.querySelector('.h1p-fond');
      if (img) img.style.transform = 'translate3d(0,' + (t * 4).toFixed(2) + '%,0) scale(1.07)';
    });

    /* 3. image epinglee : le texte actif suit la course de la section */
    pins.forEach(function (sec) {
      var slides = sec.querySelectorAll('.h1p-pin-slide');
      if (!slides.length) return;
      var r = sec.getBoundingClientRect();
      var course = sec.offsetHeight - h;
      if (course <= 0) return;
      var p = (-r.top) / course;           // 0 a l'entree, 1 a la sortie
      if (p < 0) p = 0; else if (p > 1) p = 1;
      // Chaque message occupe une bande de la course. « ecart » vaut 0 quand le
      // message est pile au centre de la sienne, et un demi quand il touche le
      // bord. L'opacite tombe exactement au passage de temoin : le texte sortant
      // a fini de disparaitre au moment ou le suivant commence a monter.
      var n = slides.length;
      var pos = p * n;
      for (var j = 0; j < n; j++) {
        var ecart = pos - (j + 0.5);
        if (j === 0 && ecart < 0) ecart = 0;              // le premier attend a l'entree
        if (j === n - 1 && ecart > 0) ecart = 0;          // le dernier reste jusqu'a la sortie
        var o = 1 - Math.abs(ecart) * 1.9;
        if (o < 0) o = 0; else if (o > 1) o = 1;
        var d = slides[j];
        d.style.opacity = o.toFixed(3);
        d.style.transform = 'translate3d(0,' + (-ecart * 58).toFixed(1) + 'px,0)';
        d.style.visibility = o > 0.01 ? 'visible' : 'hidden';
      }
      var barre = sec.querySelector('.h1p-pin-jauge span');
      if (barre) barre.style.transform = 'scaleX(' + Math.max(0.04, p).toFixed(3) + ')';
    });
  }

  function auDefilement() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(place);
  }

  window.addEventListener('scroll', auDefilement, { passive: true });
  window.addEventListener('resize', auDefilement);
  window.addEventListener('load', auDefilement);
  place();
})();
